import styled from 'styled-components';
import media from '../../../../../constants/media';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
`;

export const Stars = styled.div`
	display: flex;
	justify-content: center;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	margin-top: 2rem;

	${media.mobileOnly`
		flex-direction: column;
		button {
			width: 100%;
			&:first-child {
				margin-bottom: 1.5rem;
			}
		}
	`};
`;
